// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productGrid":"styles__productGrid__aAaL-","item":"styles__item__Wve_B","info":"styles__info__MSuus"};